var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grid-item",style:({ flexGrow: _vm.grow, marginRight: _vm.margin, maxWidth: _vm.width })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }